import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../app-environments/environment';
import {LoginService} from '../../services/login.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-application-offline',
  templateUrl: './application-offline.component.html',
  styleUrls: ['./application-offline.component.css']
})
export class ApplicationOfflineComponent implements OnInit {
  applicationOfflineMsg: string;

  constructor(private loginService: LoginService, private router: Router) {
    this.loadSettings();
  }

  loadSettings(): void {
    const me: any = this;
    this.loginService.loadSettings().subscribe((vars: any) => {
         me.applicationOfflineMsg = vars.applicationOfflineMsgText;
      if (!vars.isApplicationOffline) {
        me.router.navigate(['/login']);
      }
      }, err => {
        console.log(err);
      }
    );
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/application-offline/application-offline.component.ts